(function () {
  'use strict';

  var commonDescriptionLabels = new Set([
    'how to apply', 'application', 'directions', 'ingredients',
    "what's included", 'whats included', 'product details', 'details',
    'care instructions', 'shipping', 'shipping & returns', 'shipping and returns',
    'returns', 'faq', 'faqs', 'tips', 'pro tips', 'lash tech tips',
    'removal', 'how to remove', 'storage', 'warning', 'warnings'
  ]);

  function bool(value) {
    return value === true || value === 'true';
  }

  function normalizeLabel(value) {
    return (value || '')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/[:\s]+$/g, '')
      .trim()
      .toLowerCase();
  }

  function isKnownParagraphLabel(element) {
    if (!element || !/^(P|STRONG|B)$/.test(element.tagName)) return false;
    var normalized = normalizeLabel(element.textContent);
    if (!commonDescriptionLabels.has(normalized)) return false;

    if (element.tagName === 'STRONG' || element.tagName === 'B') return true;

    var meaningfulChildren = Array.prototype.filter.call(element.childNodes, function (node) {
      return node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim());
    });

    if (meaningfulChildren.length !== 1 || meaningfulChildren[0].nodeType !== 1) return false;
    return /^(STRONG|B)$/.test(meaningfulChildren[0].tagName);
  }

  function descriptionTrigger(element, wrapper) {
    if (!element || element.nodeType !== 1) return false;
    var tag = element.tagName.toLowerCase();
    if (tag === 'h2' && bool(wrapper.dataset.headingH2)) return true;
    if (tag === 'h3' && bool(wrapper.dataset.headingH3)) return true;
    if (tag === 'h4' && bool(wrapper.dataset.headingH4)) return true;
    return bool(wrapper.dataset.commonLabels) && isKnownParagraphLabel(element);
  }

  function buildDescriptionAccordions(wrapper) {
    if (!wrapper || wrapper.dataset.vlReady === 'true') return;
    wrapper.dataset.vlReady = 'true';

    if (!bool(wrapper.dataset.auto)) return;

    var source = wrapper.querySelector('[data-vl-description-source]');
    if (!source) return;

    var nodes = Array.prototype.slice.call(source.childNodes);
    var triggerIndexes = [];

    nodes.forEach(function (node, index) {
      if (descriptionTrigger(node, wrapper)) triggerIndexes.push(index);
    });

    if (!triggerIndexes.length) return;

    var intro = document.createElement('div');
    intro.className = 'vl-product-description__intro Rte';

    nodes.slice(0, triggerIndexes[0]).forEach(function (node) {
      intro.appendChild(node);
    });

    var accordion = document.createElement('div');
    accordion.className = 'vl-product-description__accordions';
    accordion.dataset.vlAccordionGroup = '';
    accordion.dataset.multiple = wrapper.dataset.multiple;

    triggerIndexes.forEach(function (triggerIndex, sectionIndex) {
      var trigger = nodes[triggerIndex];
      var endIndex = triggerIndexes[sectionIndex + 1] || nodes.length;
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var body = document.createElement('div');

      details.className = 'vl-accordion';
      details.dataset.vlAccordion = '';
      if (sectionIndex === 0 && bool(wrapper.dataset.firstOpen)) details.open = true;

      summary.className = 'vl-accordion__summary';
      summary.textContent = trigger.textContent.trim();
      summary.dataset.icon = wrapper.dataset.icon || 'plus';

      body.className = 'vl-accordion__body Rte';
      nodes.slice(triggerIndex + 1, endIndex).forEach(function (node) {
        body.appendChild(node);
      });

      details.appendChild(summary);
      details.appendChild(body);
      accordion.appendChild(details);
      trigger.remove();
    });

    source.replaceChildren();
    if (intro.textContent.trim() || intro.querySelector('*')) source.appendChild(intro);
    source.appendChild(accordion);
  }

  function initDescriptionAccordions(root) {
    (root || document).querySelectorAll('[data-vl-description]').forEach(buildDescriptionAccordions);
  }

  function initAccordionGroups(root) {
    (root || document).querySelectorAll('[data-vl-accordion-group]').forEach(function (group) {
      if (group.dataset.vlBound === 'true') return;
      group.dataset.vlBound = 'true';
      group.addEventListener('toggle', function (event) {
        var details = event.target;
        if (details.tagName !== 'DETAILS' || !details.open || bool(group.dataset.multiple)) return;
        group.querySelectorAll('details[open]').forEach(function (item) {
          if (item !== details) item.removeAttribute('open');
        });
      }, true);
    });
  }

  var activeVideo = null;

  function pauseVideo(video) {
    if (!video || video.paused) return;
    video.pause();
  }

  function updateVideoButton(card, video) {
    var playButton = card.querySelector('[data-vl-video-play]');
    var muteButton = card.querySelector('[data-vl-video-mute]');
    if (playButton) {
      playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      playButton.textContent = video.paused ? 'Play' : 'Pause';
    }
    if (muteButton) {
      muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      muteButton.textContent = video.muted ? 'Sound on' : 'Mute';
    }
  }

  function initVideos(root) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards = (root || document).querySelectorAll('[data-vl-video-card]');

    cards.forEach(function (card) {
      if (card.dataset.vlVideoBound === 'true') return;
      card.dataset.vlVideoBound = 'true';

      var video = card.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'metadata';

      card.querySelector('[data-vl-video-play]')?.addEventListener('click', function () {
        if (video.paused) {
          if (activeVideo && activeVideo !== video) pauseVideo(activeVideo);
          activeVideo = video;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
        updateVideoButton(card, video);
      });

      card.querySelector('[data-vl-video-mute]')?.addEventListener('click', function () {
        video.muted = !video.muted;
        updateVideoButton(card, video);
      });

      ['play', 'pause', 'volumechange', 'ended'].forEach(function (eventName) {
        video.addEventListener(eventName, function () { updateVideoButton(card, video); });
      });

      updateVideoButton(card, video);
    });

    if (reducedMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.72) {
          if (activeVideo && activeVideo !== video) pauseVideo(activeVideo);
          activeVideo = video;
          video.play().catch(function () {});
        } else {
          pauseVideo(video);
        }
        updateVideoButton(entry.target, video);
      });
    }, { threshold: [0, 0.72] });

    cards.forEach(function (card) { observer.observe(card); });
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-vl-carousel]').forEach(function (carousel) {
      if (carousel.dataset.vlCarouselBound === 'true') return;
      carousel.dataset.vlCarouselBound = 'true';

      var track = carousel.querySelector('[data-vl-carousel-track]');
      if (!track) return;

      carousel.querySelectorAll('[data-vl-carousel-direction]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = button.dataset.vlCarouselDirection === 'previous' ? -1 : 1;
          track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.78), behavior: 'smooth' });
        });
      });
    });
  }

  function init(root) {
    initDescriptionAccordions(root);
    initAccordionGroups(root);
    initVideos(root);
    initCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();